import React from "react";
import { } from 'react-redux';
import { useTranslation } from "react-i18next";

import {
  Row,
  Col,
  Button,
} from '@lockerpm/design';

import {
  DeleteOutlined
} from "@ant-design/icons";

const MultipleSelect = (props) => {
  const {
    className = '',
    selectedRowKeys = [],
    callingAPI = false,
    onDelete = () => { },
    onCancel = () => { }
  } = props;

  const { t } = useTranslation()

  return (
    <Row
      className={`${className} filter`}
      justify={'space-between'}
      gutter={[0, 8]}
    >
      <Col>
        <Row
          align={'middle'}
          justify={'left'}
          gutter={[16, 16]}
        >
          <Col>
            <p className="text-s">{t('common.selected_items', { amount: selectedRowKeys.length })}</p>
          </Col>
          <Col>
            <Button
              size="medium"
              ghost
              type={'primary'}
              loading={callingAPI}
              danger
              onClick={() => onDelete()}
              icon={<DeleteOutlined />}
            >
              {t('button.delete')}
            </Button>
          </Col>
          <Col>
            <Button
              size="medium"
              disabled={callingAPI}
              onClick={() => onCancel()}
            >
              {t('button.cancel')}
            </Button>
          </Col>
        </Row>
      </Col>
    </Row>
  );
}

export default MultipleSelect;